import React, { useEffect, useState } from 'react'
// import Blogs from '../../Section/Blogs'
import { Icon } from '@iconify/react/dist/iconify.js'
import { Link, useNavigate } from 'react-router-dom'
import '../Assets/CSS/BlogPage.css'
import ContactUs from '../sections/home/Contactus';
import Login from '../components/auth/login/Login';
const Blogpage = ({ isAuthenticated }) => {
    const [blogdata, setBlogData] = useState([])
    const Navigate = useNavigate();
        const [loading, setLoading] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [selectedBlog, setSelectedBlog] = useState(null);
    useEffect(() => {
        fetchBlogs();
    }, []);
    const fetchBlogs = async () => {
        setLoading(true);
        try {
            // await new Promise(resolve => setTimeout(resolve, 2000));

            const response = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/blog/allblogs`)
            const data = await response.json();
            setBlogData(data);
            console.log(blogdata);

        } catch (error) {
            console.error("Error fetching daily attendance data:", error);
        }
        finally{
            setLoading(false);
        }
    };
    const renderBlog = (blog) => (
        <div key={blog.blogId} className='col-lg-4 col-md-12 col-sm-12 mb-4'>
            <div onClick={() => handleBlogClick(blog.blogId)}
                className="text-decoration-none text-dark cursor-pointer">
                <div className="blog-card card " style={{ cursor: 'pointer' }}>
                    <img src={blog.blogImage[0]}
                        style={{
                            height: '250px',
                            borderRadius: '20px', overflow: 'hidden'
                        }}
                        alt={`blog${blog.blogId}`}
                        className="card-img-top px-2 py-2"
                    />
                    <h1 className='blog-title pt-2'>{blog.blogTitle}</h1>
                    <p className='desc'>{blog.blogDescription.slice(0,80)}<span>...</span></p>
                </div>
            </div>
        </div>

    );
    const handleBlogClick = (blogId) => {
        console.log(isAuthenticated, "ISUAsbJSBsbjS");

        // Check if the user is authorized
        // const token = localStorage.getItem('token'); // Assuming token is stored in localStorage
        if (isAuthenticated) {
            // Navigate to the event detail page
            Navigate(`/blogdetail/${blogId}`);
        }
        else {
            setShowLoginModal(true);
            // Show login modal
            setSelectedBlog(blogId);
        }

    };
    const renderSkeletonLoader = () => {
        return Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className='col-lg-4 col-md-12 col-sm-12 mb-4'>
                <div className="blog-card card px-2 py-2" style={{ cursor: 'not-allowed' }}>
                    <div
                        style={{
                            width: '100%',
                            height: '200px',
                            backgroundColor: '#e0e0e0',
                            animation: 'pulse 1.5s infinite',
                            borderRadius: '10px'
                        }}
                    ></div>
                    <div
                        style={{
                            height: '20px',
                            width: '60%',
                            marginTop: '15px',
                            backgroundColor: '#e0e0e0',
                            animation: 'pulse 1.5s infinite',
                            borderRadius: '5px'
                        }}
                    ></div>
                    <div
                        style={{
                            height: '14px',
                            width: '80%',
                            marginTop: '10px',
                            backgroundColor: '#e0e0e0',
                            animation: 'pulse 1.5s infinite',
                            borderRadius: '5px'
                        }}
                    ></div>
                    <div
                        style={{
                            height: '10px',
                            width: '40%',
                            marginTop: '8px',
                            backgroundColor: '#e0e0e0',
                            animation: 'pulse 1.5s infinite',
                            borderRadius: '5px'
                        }}
                    ></div>
                </div>
            </div>
        ));
    };
    const handleCloseLogin = () => {
        // Close login modal
        setShowLoginModal(false);
        setSelectedBlog(null);
    }
    return (
        <div className='common-margin' >
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12 bannerimg pb-4 mt-3'>
                        <h1 className='blog-heading p-2 d-flex align-items-center justify-content-start'>
                                                      <span className='d-flex justify-content-start align-items-center'>
                                                            <Link to='/' className='text-white text-decoration-none'>
                                                                <Icon icon="iconamoon:home-thin" className='fs-4 pb-1 me-1 ' />
                                                            </Link>
                                                            <Icon icon="weui:arrow-outlined" className='fs-4  me-1' />
                                                            <span className='fs-6 me-1'>Blogs</span>
                                                        </span>
                            
                            {/* <Link to='/' className='text-white text-decoration-none'><Icon icon="iconamoon:home-thin" className='fs-5 me-1' /></Link>
                            <Icon icon="weui:arrow-outlined" className='fs-5 ms-1 me-1' />Blogs */}
                        </h1>
                        <h2 className='blog-headingtwo'>Blogs</h2>
                    </div>
                </div>

                {/* Dynamic First Blog Item */}
                <div className='container mt-md-5 mt-2'>

                    {/* Render Remaining Blogs */}
                    <div className='row'>
                    {loading ? renderSkeletonLoader() :
                         blogdata.slice(1).map(blog => renderBlog(blog))}
                        {/* {blogdata.slice(1).map(blog => renderBlog(blog))} */}

                    </div>
                </div>
            </div>

            <ContactUs />
            {showLoginModal && (<Login onClose={handleCloseLogin} loginopen={showLoginModal} />
            )}

        </div>


    )
}

export default Blogpage;